import { Row, Text, Switch, useCurrentUser, MainTabEnum } from '@rivallapp/volosports-components';
import { useDiscoverStore } from '../../../../zustand-stores';

const TotalWithFeesToggle = () => {
  const { currentUser } = useCurrentUser();
  const { shouldSeePricesWithFees: userShouldSeePriceWithFees } = currentUser;

  const shouldSeePricesWithFees = useDiscoverStore(store => store.shouldSeePricesWithFees);
  const isRental = useDiscoverStore(store => store.view === MainTabEnum.COURT_RENTALS);

  const handeValueChange = (value: boolean) => {
    useDiscoverStore.setState({ shouldSeePricesWithFees: value });
  };

  if (!userShouldSeePriceWithFees || isRental) return null;

  return (
    <Row p={3} shadow={2} borderRadius="sm" alignItems="center" mr={2} alignSelf="flex-end">
      <Text fontSize="sm">Display Total With Fees</Text>
      <Switch ml={2} value={shouldSeePricesWithFees} onValueChange={handeValueChange} />
    </Row>
  );
};

export default TotalWithFeesToggle;
